import { createContext, useContext, useMemo, useState } from 'react'

type IGarbageManualContext = {
  registerCollector: (key: string, collector: () => void) => void
  registerUrlException: (urlException: string) => void
  purge: () => void
  purgeUrlExceptions: () => void
}

const GarbageManualContext = createContext<IGarbageManualContext>({
  registerCollector: (key: string, collector: () => void) => null,
  registerUrlException: (urlException: string) => null,
  purge: () => null,
  purgeUrlExceptions: () => null
})

export const GarbageManualProvider = ({ children }: any) => {
  const [urlExceptions, setUrlExceptions] = useState<string[]>([])
  const [collectors, setCollectors] = useState<{ key: string; collector: () => void }[]>([])

  const runCollectors = () => {
    for (let i = 0; i < collectors.length; i++) {
      const { key, collector } = collectors[i]

      console.log('Running garbage collection on: ', key)

      collector()
    }
    setUrlExceptions([])
  }

  const state = useMemo(
    () => ({
      registerCollector: (key: string, collector: () => void) => {
        const cloned = [...collectors]
        const index = cloned.findIndex((c) => c.key === key)

        if (index === -1) {
          setCollectors([...cloned, { key, collector }])
        } else {
          cloned[index] = { key, collector }
          setCollectors([...cloned])
        }
      },
      registerUrlException: (urlException: string) => {
        const cloned = [...urlExceptions]
        const index = cloned.findIndex((e) => e === urlException)

        if (index === -1) {
          setUrlExceptions([...cloned, urlException])
        }
      },
      // runCollector: (key: string) => {
      //   const c = collectors.find((c) => c.key === key)

      //   console.log('RUNNING COLLECTOR', key)

      //   if (c) {
      //     c.collector()
      //     setCollectors([...collectors.filter((c) => c.key !== key)])
      //   }
      // },
      purge: () => {
        runCollectors()
      },
      purgeUrlExceptions: () => {
        setUrlExceptions([])
      }
    }),
    [collectors]
  )

  return <GarbageManualContext.Provider value={state}>{children}</GarbageManualContext.Provider>
}

export const useGarbageManualCollector = () => useContext(GarbageManualContext)
